var map = {
	"./align-down.svg": 60191,
	"./align-horizontal.svg": 14387,
	"./align-left.svg": 50752,
	"./align-right.svg": 69231,
	"./align-up.svg": 64496,
	"./align-vertical.svg": 34377,
	"./flip-horizontal.svg": 9483,
	"./flip-vertical.svg": 36465,
	"./position-1.svg": 6560,
	"./position-2.svg": 27315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20527;